// The global fetch behind an importable module seam. Two reasons to use it
// over the global: (1) it delegates to globalThis.fetch through a wrapper,
// so the binding is safe to pass around as a bare function reference (the
// browser's own fetch can throw "Illegal invocation" when called detached)
// and it reaches the fetch installed at call time, in a browser and in node
// alike — a stub or an interceptor put in place after this module loaded
// included; (2) a module import is a single stubbable seam — network-touching
// layers that route through it can be tested by mocking this module instead
// of patching globals. Identical signature and behavior to native fetch
// otherwise — args and return pass through untouched.
export const fetch: typeof globalThis.fetch = (...args) =>
  globalThis.fetch(...args);
